<template>
  <v-card elevation="2">
    <v-toolbar elevation="0" dense>
      <v-text-field
        :label="$t('dialog.company_selection.filter')"
        v-model="filter"
        solo
        flat
        hide-details
        style="width: 40px; margin-left: -12px;"
        prepend-inner-icon="mdi-filter"
        clearable
      ></v-text-field>

      <v-spacer></v-spacer>

      <v-tooltip style="z-index: 4000" bottom open-delay="500">
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" @click="selectAll">
            <v-icon>done_all</v-icon>
          </v-btn>
        </template>
        <span>{{ $t("common.select_all_filtered_itms") }}</span>
      </v-tooltip>

      <v-tooltip style="z-index: 4000" bottom open-delay="500">
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" @click="selectNone">
            <v-icon>remove_done</v-icon>
          </v-btn>
        </template>
        <span>{{ $t("common.select_none_filtered_itms") }}</span>
      </v-tooltip>

      <v-divider vertical inset class="my-2" />

      <template v-if="inverseSelection !== null">
        <v-tooltip style="z-index: 4000" bottom open-delay="500">
          <template v-slot:activator="{ on }">
            <v-btn small elevation="0" v-on="on" :color="(inverseSelection) ? 'primary' : 'default'"
                   @click="toggleInverseSelection">
              {{ $t("component.items_selection.inverse_toggle") }}&nbsp;⦁&nbsp;<b>
              <span v-if="inverseSelection"
                    class="red--text text--lighten-3">{{ $t("component.items_selection.inverse_on") }}</span>
              <span v-else class="grey--text">{{ $t("component.items_selection.inverse_off") }}</span>
            </b>
            </v-btn>
          </template>
          <span>{{ invereseTooltip }}</span>
        </v-tooltip>
      </template>

      <v-tooltip style="z-index: 4000" bottom open-delay="500">
        <template v-slot:activator="{ on }">
          <v-btn icon @click="toggleFullsreen" v-on="on">
            <v-icon v-if="!fullscreen">fullscreen</v-icon>
            <v-icon v-else>fullscreen_exit</v-icon>
          </v-btn>
        </template>
        <span>{{ $t("component.items_selection.toggle_fullsreen") }}</span>
      </v-tooltip>

    </v-toolbar>

    <v-divider class="mx-2" />

    <v-list>
      <v-virtual-scroll :items="filteredItems"
                        bench="64"
                        min-height="64px"
                        :max-height="fullscreenHeight"
                        item-height="54">
        <template v-slot:default="{ item }">
          <v-list-item :key="item.id" @click="selectItem(item)">
            <v-list-item-action>
              <v-checkbox :input-value="isSelected(item)" />
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ item.name }}</v-list-item-title>
              <v-list-item-subtitle v-if="item.note !== undefined && item.note !== null">{{ item.note }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-virtual-scroll>
    </v-list>
  </v-card>
</template>

<script>

export default {
  name: "ItemsSelection",

  props: {
    value: {
      type: Array,
      mandatory: true
    },
    items: {
      type: Array,
      mandatory: true
    },
    inverse: {
      type: Boolean,
      default: null
    },
    mapper: {
      type: Function
    },
    maxHeight: {
      type: String,
      default: "540px"
    },
    invereseTooltip: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      filter: "",
      selected: [],
      fullscreen: false,
      inverseSelection: null
    };
  },

  methods: {
    toggleFullsreen() {
      this.fullscreen = !this.fullscreen;
    },

    toggleInverseSelection() {
      this.inverseSelection = !this.inverseSelection;
      this.$emit("inverse", this.inverseSelection);
    },

    selectItem(item) {
      if (this.isSelected(item)) {
        this.selected = this.selected.filter(x => x !== item.id);
        this.$emit("input", this.selected);
      } else {
        this.selected.push(item.id);
        this.$emit("input", this.selected);
      }
    },

    isSelected(item) {
      return this.selected.filter(x => x === item.id).length > 0;
    },

    selectNone() {
      const none = this.filteredItems.map(x => x.id);
      this.selected = this.selected.filter(x => !none.includes(x));
      this.$emit("input", this.selected);
    },

    selectAll() {
      this.selected = [...new Set(this.selected.concat(this.filteredItems.map(x => x.id)))];
      this.$emit("input", this.selected);
    }
  },

  computed: {
    filteredItems() {
      if (this.filter === null || this.filter.length === 0)
        return this.items.map(x => this.mapper(x));
      else
        return this.items.map(x => this.mapper(x)).filter(
          x => x.name.toLowerCase().includes(this.filter.toLowerCase())
            || (x.note && x.note.toLowerCase().includes(this.filter.toLowerCase())));
    },

    fullscreenHeight() {
      return (this.fullscreen) ? "540000px" : this.maxHeight;
    }
  },

  watch: {
    value: function() {
      this.selected = this.value;
    },

    inverse: function() {
      this.inverseSelection = this.inverse;
    }
  },

  mounted() {
    this.selected = this.value;
    this.inverseSelection = this.inverse;
  }
};
</script>

<style scoped>
</style>